module.exports = __webpack_public_path__ + "static/media/IMG-20181114-WA0000.082496e7.jpg";